"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var utils_1 = require("../../../../../utils/utils");
var StyledDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var $isOption = _a.$isOption;
    return !$isOption && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: #fff;\n      padding: 1rem;\n      position: relative;\n    "], ["\n      background-color: #fff;\n      padding: 1rem;\n      position: relative;\n    "])));
});
var StyledText = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  white-space: pre-wrap;\n  margin-top: 0.5em;\n  display: inline-block;\n\n  :first-letter {\n    text-transform: uppercase;\n  }\n"], ["\n  white-space: pre-wrap;\n  margin-top: 0.5em;\n  display: inline-block;\n\n  :first-letter {\n    text-transform: uppercase;\n  }\n"])));
var StyledCloseButton = styled_components_1.default(icons_1.CloseCircleFilled)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  font-size: 16px;\n  color: #2362a2;\n"], ["\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  font-size: 16px;\n  color: #2362a2;\n"])));
var DivWithRightPadding = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding-right: 2rem;\n  position: relative;\n"], ["\n  padding-right: 2rem;\n  position: relative;\n"])));
var DruhyOsobUkonOption = function (_a) {
    var className = _a.className, tlumocnik = _a.tlumocnik, onRemove = _a.onRemove;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(DivWithRightPadding, null,
            react_1.default.createElement("strong", null, utils_1.getNameFromTlumocnik(tlumocnik)),
            onRemove && react_1.default.createElement(StyledCloseButton, { onClick: onRemove })),
        react_1.default.createElement(StyledText, null, tlumocnik.druhOsobyNazev + "    I\u010CO:",
            "\u00A0", (tlumocnik.ico || '') + "    ",
            "Datov\u00E1\u00A0schr\u00E1nka:\u00A0", (tlumocnik.datovaSchranka || '') + " ")));
};
DruhyOsobUkonOption.defaultProps = {
    className: undefined,
    onRemove: undefined,
};
exports.default = styled_components_1.default(DruhyOsobUkonOption)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
